module.exports = __webpack_public_path__ + "static/media/blank_2_1.0974ed87.png";